import aesReduxConstants from '../constants';
import mapSetApi from '../apis/mapSetApi';

const mapSetActions = function() {
  const actions = {};
  const constants = aesReduxConstants.MAP_SET;

  const getActionType = function(action, status) {
    let actionType = null;

    if (constants.hasOwnProperty(action.toUpperCase())) {
      actionType = constants[action.toUpperCase()];
    }

    if (status && actionType !== null) {
      actionType += (`_${status.toUpperCase()}`);
    }

    return actionType;
  };


  const getOptions = function(type, context, id) {
    const options = {};

    if (type === 'global') {
      return options;
    }

    options.clientId = context.clientId;

    if (type === 'user') {
      options.userId = context.userId;
    }

    if (id) {
      options.id = id;
    }

    return options;
  };


  /*
   * Create Map Set
   */
  actions.createMapSet = function(type, mapSet) {
    return function(dispatch, getState) {
      const actionType = getActionType('create', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context);

      const success = function() {
        dispatch({ type: getActionType('create', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to create Map Set';

        dispatch({ type: getActionType('create', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapSetApi.createMapSet(options, mapSet).then(success, failure);
    };
  };


  /*
   * Delete Map Set
   */
  actions.deleteMapSet = function(type, id) {
    return function(dispatch, getState) {
      const actionType = getActionType('delete', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, id);

      const success = function() {
        dispatch({ type: getActionType('delete', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to delete Map Set';

        dispatch({ type: getActionType('delete', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapSetApi.deleteMapSet(options).then(success, failure);
    };
  };


  /*
   * Get Map Set
   */
  actions.getMapSet = function(type, id) {
    return function(dispatch, getState) {
      const actionType = getActionType('get', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, id);

      dispatch({ type: actionType });

      const success = function(response) {
        dispatch({ type: getActionType('get', 'success'), payload: response.data });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to retrieve Map Set';

        dispatch({ type: getActionType('get', 'failure'), error });

        throw error;
      };

      return mapSetApi.getMapSet(options).then(success, failure);
    };
  };


  /*
   * Get Map Sets
   */
  actions.getMapSets = function(type) {
    return function(dispatch, getState) {
      const actionType = getActionType('get_all', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context);
      const { useCache } = getState().map.mapSets;

      const success = function(response) {
        let data = response.data.list;

        if (response.data.hasOwnProperty('clientList')) data = [].concat(data, response.data.clientList);

        dispatch({ type: getActionType('get_all', 'success'), payload: data, meta: { useCache } });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to retrieve Map Set List';

        dispatch({ type: getActionType('get_all', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapSetApi.getMapSets(options).then(success, failure);
    };
  };


  /*
   * Set Default Map Set
   */
  actions.setDefaultMapSet = function(type, id) {
    return function(dispatch, getState) {
      const actionType = getActionType('set_default', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, id);

      const success = function() {
        dispatch({ type: getActionType('set_default', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to set default Map Set';

        dispatch({ type: getActionType('set_default', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapSetApi.setDefaultMapSet(options).then(success, failure);
    };
  };


  /*
   * Update Map Set
   */
  actions.updateMapSet = function(type, mapSet) {
    return function(dispatch, getState) {
      const actionType = getActionType('update', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, mapSet.id);

      const success = function() {
        dispatch({ type: getActionType('update', 'success'), payload: mapSet });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to update Map Set';

        dispatch({ type: getActionType('update', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapSetApi.updateMapSet(options, mapSet).then(success, failure);
    };
  };

  return actions;
};
export default mapSetActions();
